import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { PolicyService } from 'src/app/modules/policy/policy.service';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { IFormKey, IFormSelectOption } from '../../models/forms';
import {
  EVariationOptions,
  frequency_premium_change_form_keys,
  frequency_premium_change_previdenziali_form_keys,
  premium_amount_change_previdenziali_form_keys,
  variation_options_form_keys
} from './frequency-premium-change.constants';

@Component({
  selector: 'app-frequency-premium-change',
  templateUrl: './frequency-premium-change.component.html',
  styleUrl: './frequency-premium-change.component.scss',
})
export class FrequencyPremiumChange implements OnChanges, OnInit, OnDestroy {
  @Input() form: FormGroup;
  @Input() variationOptionsForm?: FormGroup;
  @Input() frequenciesList: string[] | IFormSelectOption[];
  @Input() currentFrequency: string;
  @Input() currentInstallmentAmount: string;

  formKeys: IFormKey[];
  variationOptionsFormKeys: IFormKey[];
  showMainForm: boolean;

  destroy$ = new Subject();

  constructor(private _policyService: PolicyService) {}

  ngOnInit(): void {
    this.formKeys = CommonUtils.assign(frequency_premium_change_form_keys);

    this.variationOptionsFormKeys = CommonUtils.assign(
      variation_options_form_keys
    );

    if (this.isPolicyPrevidenziale) {
      this.variationOptionsForm?.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe((newVal) => {
          this.showMainForm = newVal;

          const oldOptions = this.formKeys.find(
            (key) => key.controlName === 'frequency'
          ).options;

          this.updateFormTemplate(newVal);

          this.formKeys.find((key) => key.controlName === 'frequency').options =
            oldOptions;

          // TODO: Look into why this method is needed and the assign to formKeys is not enough.
          this.updateFormKeysOptions();
        });
      // this.valorizeFormValues();
    }

    this.showMainForm = !this.isPolicyPrevidenziale;
    this.initializeFrequenciesList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['frequenciesList'] && changes['frequenciesList'].currentValue) {
      this.initializeFrequenciesList();
    } else if (this.isPolicyPrevidenziale) {
      if (
        (changes['currentFrequency'] &&
          changes['currentFrequency'].currentValue) ||
        (changes['currentInstallmentAmount'] &&
          changes['currentInstallmentAmount'].currentValue)
      ) {
        this.initializeFormValues();
      }
    }
  }

  public updateFormTemplate(value: any) {
    if (value.variationOptions === EVariationOptions.FREQUENCY) {
      this.formKeys = CommonUtils.assign(
        frequency_premium_change_previdenziali_form_keys
      );
      this.form.get('requestMonth').addValidators(Validators.required);
      this.form.get('requestDay').addValidators(Validators.required);
    } else {
      this.formKeys = CommonUtils.assign(
        premium_amount_change_previdenziali_form_keys
      );
      this.form.get('requestMonth').removeValidators(Validators.required);
      this.form.get('requestDay').removeValidators(Validators.required);
    }
  }

  public updateFormKeysOptions() {
    this.formKeys.forEach((key) => {
      if (key.readonly) {
        this.form.get(key.controlName).disable();
      } else {
        this.form.get(key.controlName).enable();
      }

      if (key.defaultValue) {
        this.form.get(key.controlName).setValue(key.defaultValue);
      } else {
        this.form.get(key.controlName).setValue(null);
      }
    });
    this.initializeFormValues();
  }

  public initializeFormValues() {
    this.form.get('amount').setValue(this.currentInstallmentAmount);
    this.form
      .get('frequency')
      .patchValue(
        (
          this.frequenciesList.find(
            (freq: IFormSelectOption) => freq.key == this.currentFrequency
          ) as IFormSelectOption
        )?.key
      );
  }

  public initializeFrequenciesList() {
    if (this.formKeys && this.frequenciesList) {
      const options = [];

      this.frequenciesList.reverse();
      this.frequenciesList.forEach((freq, index) => {
        options.push(
          this.isPolicyPrevidenziale
            ? {
                key: (freq as IFormSelectOption).key,
                value: (freq as IFormSelectOption).value?.trim(),
              }
            : {
                key: index,
                value: freq,
              }
        );
      });
      this.formKeys.forEach((key) => {
        if (key?.controlName === 'frequency') {
          key.options = options;
        }
      });
    }
  }

  get isPolicyPrevidenziale(): boolean {
    return this._policyService.isDetailPrevidenziale;
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
